import { Pipe, PipeTransform } from '@angular/core';
import { FormUtils } from '@app/utils/form-utils';

@Pipe({
    name: 'textByType',
})
export class TextByTypePipe implements PipeTransform {
    public transform(inputName: string, classConfig: any, typeValue: string): string {
        return FormUtils.textByType(classConfig, inputName, typeValue);
    }
}
